import { css, cx } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import type { LegacyButtonSize } from '../button-type';
import { buttonBaseStyle, buttonFocusStyle, baseButtonStyles } from '../common.styles';
import type { PrimaryButtonProps } from './types';

type StyleProps = Pick<PrimaryButtonProps, 'destructive' | 'size'>;

const primaryButtonDefaultStyle = css`
  background: ${theme.colors.primary50};
  border: 1px solid ${theme.colors.primary50};
  border-radius: ${theme.borderRadius.small};
  color: ${theme.colors.white};
  font-weight: ${theme.font.weight.bold};
  transition: background 150ms ease-out, color 150ms ease-out, border-color 150ms ease-out;

  &:hover {
    background: ${theme.colors.primary70};
    border-color: ${theme.colors.primary70};
    box-shadow: ${theme.shadows.heavy};
  }

  &:active {
    background: ${theme.colors.primary80};
    border-color: ${theme.colors.primary80};
    box-shadow: none;
  }

  &:disabled {
    background: ${theme.colors.status.disabled};
    border-color: ${theme.colors.status.disabled};
    box-shadow: none;
    color: ${theme.colors.white};
  }

  svg {
    margin-left: ${theme.spacing(1)};
  }
`;

const primaryButtonDestructiveStyle = css`
  background: ${theme.colors.status.critical};
  border-color: ${theme.colors.status.critical};

  &:hover {
    background: ${theme.colors.status.criticalHover};
    border-color: ${theme.colors.status.criticalHover};
  }

  &:active {
    background: ${theme.colors.status.criticalPressed};
    border-color: ${theme.colors.status.criticalPressed};
  }
`;

export const PrimaryButtonStyles = {
  primaryButton: ({ size = 'large' as LegacyButtonSize, destructive }: StyleProps): string =>
    cx(
      buttonBaseStyle,
      buttonFocusStyle,
      baseButtonStyles[size],
      primaryButtonDefaultStyle,
      destructive && primaryButtonDestructiveStyle
    ),
};
